import { MasterDialog } from "#common/Dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { jobProfileIdDelete } from "#job-profile/services/api"
import { Typography } from "@mui/material"
import { Fragment, useMemo, useState } from "react"

export default function DeactivatedDialog({ open, setOpen, profileData, refresh }) {
	const [disabled, setDisabled] = useState(false)
	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setOpen(false)
		setDisabled(false)
	}
	const { fetch } = useApiSend(jobProfileIdDelete, { success, end })

	const buttons = useMemo(
		() => [
			{
				label: "Cancelar",
				onClick: () => {
					setOpen(false)
				},
				disabled: disabled,
			},
			{
				label: "deshabilitar",
				onClick: () => {
					setDisabled(true)
					fetch(profileData.id)
				},
				disabled: disabled,
			},
		],
		[disabled, setOpen, fetch, profileData.id]
	)

	return (
		<Fragment>
			<MasterDialog {...{ open, setOpen, title: "Deshabilitar ", buttons }}>
				<Typography color="text.primary" sx={{ textTransform: "uppercase" }}>
					¿Está seguro que desea deshabilitar el perfil de puesto{" "}
					<strong>{profileData.nombre}</strong>?
				</Typography>
			</MasterDialog>
		</Fragment>
	)
}
